var map = {
	"./a-gonzalez-m_mini.jpg": 5861,
	"./castellanos.jpg": 8681,
	"./gallegos.jpg": 6897,
	"./garcia_mini.jpg": 5491,
	"./gutierrez_mini.jpg": 4369,
	"./imagen.jpg": 7873,
	"./lopez_mini.jpg": 1229,
	"./orona_mini.jpg": 2990,
	"./vazquez_mini.jpg": 9570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7141;